export interface NavItem {
  label: string;
  route: string;
  options?: NavItem[]; // Use an array of NavItem for options
}

const NavItems = [
  {
    label: "Configure",
    route: "/configure",
  },
  {
    label: "Reports",
    route: "/reports",
  },
];
export default NavItems;
